import * as React from 'react';

import FileSlides32 from './FileSlides32';

export const fileSlides32 = () => <FileSlides32 />;

export default {
    title: 'Icon|Content|FileSlides32',
    component: FileSlides32,
    parameters: {
        notes: "`import FileSlides32 from 'box-ui-elements/es/icon/content/FileSlides32';`",
    },
};
